const documents = {

  'Persona fisica': {
    // LISTA DOCS
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from' : 'Installatore',
  },

  },

  'Partita IVA': {
    // LISTA DOCS
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from' : 'Installatore',
  },
  },

  'Amministratore di condominio': {
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from' : 'Installatore',
  },
  }

}

export default documents



// WEBPACK FOOTER //
// ./src/components/documents/documentsHoval.js